import * as React from 'react';

export const header1 = {
  heading: 'About This Statement'
};
export const richText1 = {
  id: 'AboutThisStatement',
  html:
    '                <p>This Privacy and Security Statement describes the privacy practices of \n'
    + '                 The Home Depot, Inc. and its subsidiaries, divisions, affiliates, brands,\n'
    + '                 and other The Home Depot companies that link to this Privacy and Security \n'
    + '                 Statement,including The Home Depot Foundation (subject to exceptions noted \n'
    + '                 in The Home Depot Foundation section below) (collectively, "The Home Depot,"\n'
    + '                 "our," “us,” or "we").It applies to the information we collect in association \n'
    + '                 with your interactions with us, including, but not limited to:</p>\n'
    + '                <p><br/></p>\n'
    + '                <ul>\n'
    + '                  <li>Use of our websites, including mobile websites </li>\n'
    + '                  <li>Visits to our stores or attendance at our events </li>\n'
    + '                  <li>Use of our applications for mobile phones, tablets, or other smart devices </li>\n'
    + '                  <li>Phone and email communications with us </li>\n'
    + '                  <li>Social media interactions on our websites and other third party websites \n'
    + '                      like Facebook, YouTube, Pinterest, Google+, Instagram, and Twitter</li>\n'
    + '                  <li>Viewing our online advertisements or emails </li>\n'
    + '                  <li>Interactions with our authorized service providers </li>\n'
    + '                 </ul>\n'
    + '                <p><br/></p>\n'
    + '                <p>It also applies to personal information that we receive from business partners \n'
    + '                   and other third parties.You can find out more information about our collection \n'
    + '                   of personal information below.</p>\n'
    + '                <p><br/></p>\n'
    + '                <p>If you are applying for a job with us, please see the end of this Privacy and \n'
    + '                 Security Statement regarding our practices with respect to the information we collect\n'
    + '                 in association with your application. The remainder of this Privacy\n'
    + '                 and Security Statement does not apply to applicant information.</p>\n'
    + '                <p><br/></p>\n'
    + '                <p>This Privacy and Security Statement does not apply to the practices of The Home \n'
    + '                   Depot Canada or The Home Depot Mexico.The privacy policy for Canada can be found\n'
    + '                    at <a href = "https://www.homedepot.ca/en/home/customer-support/privacy-and-security.html"> homedepot.ca/privacy</a> The privacy \n'
    + '                    policy for Mexico can be found at <a href = "https://www.homedepot.com.mx/aviso-privacidad"> \n'
    + '                    homedepot.com.mx/privacy</a>.Also, this policy does not apply to third-party \n'
    + '                    websites accessible through our websites. Other The Home Depot companies may\n'
    + '                    provide different privacy and security statements or policies for their business \n'
    + '                    operations that may differ from this Privacy and Security Statement. For example,\n'
    + '                    this Privacy and Security Statement does not apply to <a href = "https://www.blinds.com/"> \n'
    + '                    blinds.com</a>, <a href = "https://justblinds.com">justblinds.com</a>, <a href="https://americanblinds.com"> \n'
    + '                    americanblinds.com </a>, or <a href ="https://thecompanystore.com">thecompanystore.com</a>.\n'
    + '                    You can find the applicable description of privacy practices by clicking on the \n'
    + '                    links available on the web sites operated by the other The Home Depot companies,\n'
    + '                    or by looking in the menus of their mobile applications. </p> \n'

};
